import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { AlertHelpDialog } from '@iris-platform/iris-react-ui';
import { Query, withApollo } from 'react-apollo';
import applicationPropType from '../applicationPropType';
import UserList from './UserList';
import { GET_DOMAIN_USERS, DISABLE_USER, REVOKE_USER } from '../queries';
import { debounce } from '../../../utils';
import Helpfile from '../helpfile.json';

const styles = () => ({
  root: {},
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
});

class UsersTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: 'Application Users',
      searchTxt: '',
      searchFilter: '',
      currentPage: 1,
      recordsPerPage: 5,
      thresholdPageBtns: 10,
      formPlaceholder: 'Search Users here',
      noDataMessage: 'No Users found for this Domain',
      open: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  handleHelpOpen = (title, content) => {
    this.setState({
      open: true,
      dialogTitle: title,
      dialogContent: content,
    });
  };

  handleHelpClose = () => {
    this.setState({
      open: false,
      dialogTitle: '',
      dialogContent: '',
    });
  };

  displayUser = (user) => {
    const {
      currentPage,
      recordsPerPage,
    } = this.state;
    return (
      <UserList
        key={user.user_id}
        user={user}
        recordsPerPage={recordsPerPage}
        currentPage={currentPage}
      />
    );
  }

  onClickPage = (page) => {
    this.setState({ currentPage: page });
  }

  queryDebounce = () => {
    const { searchTxt } = this.state;
    this.setState({ searchFilter: searchTxt });
  }

  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value }, debounce(this.queryDebounce, 500));
  }

  onDisableUser = (refetch, client) => async (userId, isDisabled, message) => {
    try {
      await client.mutate({
        mutation: DISABLE_USER,
        variables: { disabledDesc: message, isDisabled, userId },
      });
      refetch();
    } catch (err) {
      // TODO notify of error
      console.log('DISABLE USER ERROR:', err);
    }
  };

  onDeleteUser = (refetch, client) => async (userId) => {
    try {
      await client.mutate({
        mutation: REVOKE_USER,
        variables: { userId },
      });
      refetch();
    } catch (err) {
      // TODO notify of error
      console.log('DISABLE USER ERROR:', err);
    }
  };

  render() {
    const { application, classes, client } = this.props;
    const {
      title,
      currentPage,
      recordsPerPage,
      searchTxt,
      searchFilter,
      thresholdPageBtns,
      formPlaceholder,
      noDataMessage,
      open,
      dialogTitle,
      dialogContent,
    } = this.state;
    const help = Helpfile.users;

    return (
      <Fragment>
        <Typography
          component="div"
          variant="subheading"
          gutterBottom
        >
          {title}
          <IconButton size="small" className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.userList.title, help.userList.content)}>
            <HelpOutlineIcon className={classes.icon} />
          </IconButton>
        </Typography>
        <br />
        <Query
          query={GET_DOMAIN_USERS}
          notifyOnNetworkStatusChange
          fetchPolicy="network-only"
          variables={{
            domain: application.domain,
            // domain: 'pop.service.srv',
            filter: searchFilter,
            skip: 0,
            limit: 0,
          }}
        >
          {({
            data,
            loading,
            error,
            refetch,
          }) => {
            if (error) return <h1>Oops, got error...</h1>;

            if (data !== {} && data.domainUsers !== undefined) {
              return (
                <UserList
                  users={loading ? [] : data.domainUsers.users}
                  isLoading={loading}
                  searchTxt={searchTxt}
                  onClickPage={this.onClickPage}
                  onChangeInput={this.onChangeInput}
                  recordsPerPage={recordsPerPage}
                  currentPage={currentPage}
                  thresholdPageBtns={thresholdPageBtns}
                  formPlaceholder={formPlaceholder}
                  onUserDisable={this.onDisableUser(refetch, client)}
                  onUserDelete={this.onDeleteUser(refetch, client)}
                />
              );
            }
            return (
              <Table>
                <TableBody>
                  <TableRow className={classes.heading}>
                    <TableCell className={classes.headContent}>{noDataMessage}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            );
          }}
        </Query>
        <AlertHelpDialog
          handleClose={this.handleHelpClose}
          open={open}
          dialogTitle={dialogTitle}
          dialogContent={dialogContent}
        />
      </Fragment>
    );
  }
}

UsersTab.propTypes = {
  classes: PropTypes.object.isRequired,
  application: applicationPropType.isRequired,
  client: PropTypes.object.isRequired,
};

export default withApollo(withStyles(styles)(UsersTab));
